"use strict";

exports.__esModule = true;
exports.StripeChartContent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _scales = require("../scales");
var _StripeChartCanvas = require("./StripeChartCanvas");
var _Axis = require("../Axis");
var _Time = require("../../Time");
var _IconsBar = require("./IconsBar");
var _StripeChartBrush = require("./StripeChartBrush");
var _Core = require("../../Core");
var _utils = require("./utils");
var _formatDurationAxisTicks = require("./formatDurationAxisTicks");
var _UiDesignContext = require("../../Theme/UiDesign/UiDesignContext");
var _excluded = ["showBrush", "brushInterval", "brushIsLocked", "brushEnableResize", "brushEnableSnapToMillis", "brushEnableSnapToTimeline", "brushEnableSnapToSelection", "brushEnableDragging", "brushSnapToMillis", "onBrushChange", "axis", "width", "height", "timeline", "instantaneousEventList", "getLabel", "getLabelColor", "getColor", "getCategoryColor", "getAlpha", "onItemClick", "time", "interval"];
var _dec, _dec2, _class, _StripeChartContent;
/* eslint-disable no-unused-vars */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var StripeChartContainer = _styledComponents["default"].div.withConfig({
  displayName: "StripeChartContent__StripeChartContainer",
  componentId: "sc-19nhok1-0"
})(["position:relative;"]);
var BrushContainer = _styledComponents["default"].div.withConfig({
  displayName: "StripeChartContent__BrushContainer",
  componentId: "sc-19nhok1-1"
})(["position:absolute;"]);
function makeState(props) {
  var interval = props.interval,
    width = props.width,
    height = props.height,
    axis = props.axis,
    instantaneousEventList = props.instantaneousEventList,
    time = props.time;
  var scale = props.scale;
  if (!scale) {
    scale = (0, _scales.createIntervalScale)(0, width, interval);
  }
  var doesEventListExist = (0, _utils.doesInstantaneousEventListExist)(instantaneousEventList);
  var canvasWidth = width;
  var stripeChartHeight = (0, _utils.getStripeChartHeight)(height, axis, instantaneousEventList);
  var instantaneousEventYPos = 0;
  var stripeChartYPos = doesEventListExist ? _utils.INSTANTANEOUS_EVENT_HEIGHT : 0;
  var axisYPos = stripeChartYPos + stripeChartHeight;
  return {
    showEventList: doesEventListExist,
    scale: scale,
    stripeChartHeight: stripeChartHeight,
    canvasWidth: canvasWidth,
    instantaneousEventYPos: instantaneousEventYPos,
    stripeChartYPos: stripeChartYPos,
    axisYPos: axisYPos
  };
}

/**
 * A stripe chart, optionally with a time axis.
 */
// eslint-disable-next-line no-shadow
var StripeChartContent = exports.StripeChartContent = (_dec = _Time.TimeContext.withContext, _dec2 = _Core.SelectionContext.withContext, _dec(_class = _dec2(_class = (_StripeChartContent = /*#__PURE__*/function (_Component) {
  function StripeChartContent() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = makeState(_this.props);
    _this.renderInstantaneousEventList = function () {
      var instantaneousEventList = _this.props.instantaneousEventList;
      var _this$state = _this.state,
        scale = _this$state.scale,
        canvasWidth = _this$state.canvasWidth,
        instantaneousEventYPos = _this$state.instantaneousEventYPos;
      return /*#__PURE__*/_react["default"].createElement("foreignObject", {
        width: canvasWidth,
        height: _utils.INSTANTANEOUS_EVENT_HEIGHT,
        y: instantaneousEventYPos
      }, /*#__PURE__*/_react["default"].createElement(_IconsBar.IconsBar, {
        width: canvasWidth,
        height: _utils.INSTANTANEOUS_EVENT_HEIGHT,
        instantaneousEventList: instantaneousEventList || [],
        scale: scale
      }));
    };
    _this.handlePointClick = function (point) {
      var _this$props = _this.props,
        timeline = _this$props.timeline,
        onItemClick = _this$props.onItemClick;
      if (typeof onItemClick !== "function") {
        return;
      }
      for (var _iterator = _createForOfIteratorHelperLoose(timeline), _step; !(_step = _iterator()).done;) {
        var item = _step.value;
        var interval = item.interval;
        if (point >= interval.startMillis && point <= interval.endMillis) {
          onItemClick(item);
          return;
        }
      }
    };
    return _this;
  }
  _inheritsLoose(StripeChartContent, _Component);
  StripeChartContent.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    return makeState(props);
  };
  var _proto = StripeChartContent.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this$props2 = this.props,
      timeline = _this$props2.timeline,
      width = _this$props2.width,
      height = _this$props2.height,
      brushInterval = _this$props2.brushInterval,
      showBrush = _this$props2.showBrush,
      instantaneousEventList = _this$props2.instantaneousEventList,
      getColor = _this$props2.getColor,
      axis = _this$props2.axis,
      showDivision = _this$props2.showDivision,
      selection = _this$props2.selection,
      getLabel = _this$props2.getLabel;
    return !(0, _reactFastCompare["default"])({
      timeline: timeline,
      width: width,
      height: height,
      brushInterval: brushInterval,
      showBrush: showBrush,
      instantaneousEventList: instantaneousEventList,
      getColor: getColor,
      axis: axis,
      showDivision: showDivision,
      getLabel: getLabel,
      selected: selection && selection.selected
    }, {
      timeline: nextProps.timeline,
      width: nextProps.width,
      height: nextProps.height,
      brushInterval: nextProps.brushInterval,
      showBrush: nextProps.showBrush,
      instantaneousEventList: nextProps.instantaneousEventList,
      getColor: nextProps.getColor,
      axis: nextProps.axis,
      showDivision: nextProps.showDivision,
      getLabel: nextProps.getLabel,
      selected: nextProps.selection && nextProps.selection.selected
    });
  };
  _proto.renderStripeChartCanvas = function renderStripeChartCanvas() {
    var _this$state2 = this.state,
      canvasWidth = _this$state2.canvasWidth,
      stripeChartHeight = _this$state2.stripeChartHeight,
      stripeChartYPos = _this$state2.stripeChartYPos,
      scale = _this$state2.scale;
    var _this$props3 = this.props,
      timeline = _this$props3.timeline,
      getColor = _this$props3.getColor,
      getCategoryColor = _this$props3.getCategoryColor,
      getAlpha = _this$props3.getAlpha,
      getLabel = _this$props3.getLabel,
      onItemClick = _this$props3.onItemClick,
      getLabelColor = _this$props3.getLabelColor,
      showDivision = _this$props3.showDivision;
    return /*#__PURE__*/_react["default"].createElement("foreignObject", {
      y: stripeChartYPos,
      width: canvasWidth,
      height: stripeChartHeight
    }, /*#__PURE__*/_react["default"].createElement(_StripeChartCanvas.StripeChartCanvas, {
      getLabelColor: getLabelColor,
      getLabel: getLabel,
      width: canvasWidth,
      height: stripeChartHeight,
      timeline: timeline,
      getColor: getColor,
      getCategoryColor: getCategoryColor,
      getAlpha: getAlpha,
      scale: scale,
      onItemClick: onItemClick,
      showDivision: showDivision
    }));
  };
  _proto.renderAxis = function renderAxis() {
    var _this$props4 = this.props,
      axis = _this$props4.axis,
      width = _this$props4.width,
      time = _this$props4.time,
      interval = _this$props4.interval;
    var _this$state3 = this.state,
      scale = _this$state3.scale,
      axisYPos = _this$state3.axisYPos;
    // Modern: fewer, wider-spaced ticks so labels never collide.
    var tickSpacing = this.context && this.context.modern ? 90 : 60;
    var tickCount = Math.max(2, Math.floor(width / tickSpacing));
    return axis ? /*#__PURE__*/_react["default"].createElement(_Axis.Axis, {
      "data-testid": "StripeChartAxis",
      scale: scale,
      width: width,
      height: _utils.AXIS_HEIGHT,
      y: axisYPos,
      tickFormat: (0, _formatDurationAxisTicks.formatDurationAxisTicks)(time),
      tickCount: tickCount,
      orientation: "BOTTOM"
    }) : null;
  };
  _proto.renderBrush = function renderBrush(extra) {
    var _this$state4 = this.state,
      canvasWidth = _this$state4.canvasWidth,
      stripeChartHeight = _this$state4.stripeChartHeight,
      stripeChartYPos = _this$state4.stripeChartYPos,
      scale = _this$state4.scale;
    var _this$props5 = this.props,
      time = _this$props5.time,
      timeline = _this$props5.timeline,
      interval = _this$props5.interval,
      brushInterval = _this$props5.brushInterval,
      onBrushChange = _this$props5.onBrushChange,
      brushEnableResize = _this$props5.brushEnableResize,
      brushIsLocked = _this$props5.brushIsLocked,
      brushSnapToMillis = _this$props5.brushSnapToMillis,
      brushEnableSnapToMillis = _this$props5.brushEnableSnapToMillis,
      brushEnableSnapToTimeline = _this$props5.brushEnableSnapToTimeline,
      brushEnableDragging = _this$props5.brushEnableDragging,
      brushEnableSnapToSelection = _this$props5.brushEnableSnapToSelection;
    var offsettedBrushOnChange = function offsettedBrushOnChange(onBrushChange) {
      return function (interval) {
        if (onBrushChange) {
          return onBrushChange(interval);
        }
      };
    };
    return /*#__PURE__*/_react["default"].createElement(BrushContainer, _extends({}, extra, {
      "data-testid": "StripeChartBrushContainer",
      style: {
        width: canvasWidth,
        height: stripeChartHeight,
        top: stripeChartYPos
      }
    }), /*#__PURE__*/_react["default"].createElement(_StripeChartBrush.StripeChartBrush, {
      key: "brush",
      brushInterval: brushInterval,
      locked: brushIsLocked,
      timeline: timeline,
      enableDragging: brushEnableDragging,
      enableSnapToSelection: brushEnableSnapToSelection,
      enableSnapToMillis: brushEnableSnapToMillis,
      enableSnapToTimeline: brushEnableSnapToTimeline,
      snapToMillis: brushSnapToMillis,
      onBrushChange: offsettedBrushOnChange(onBrushChange),
      enableResize: brushEnableResize,
      width: canvasWidth,
      interval: interval,
      onClick: this.handlePointClick,
      height: stripeChartHeight,
      scale: scale
    }));
  };
  _proto.render = function render() {
    var _this$props6 = this.props,
      showBrush = _this$props6.showBrush,
      brushInterval = _this$props6.brushInterval,
      brushIsLocked = _this$props6.brushIsLocked,
      brushEnableResize = _this$props6.brushEnableResize,
      brushEnableSnapToMillis = _this$props6.brushEnableSnapToMillis,
      brushEnableSnapToTimeline = _this$props6.brushEnableSnapToTimeline,
      brushEnableSnapToSelection = _this$props6.brushEnableSnapToSelection,
      brushEnableDragging = _this$props6.brushEnableDragging,
      brushSnapToMillis = _this$props6.brushSnapToMillis,
      onBrushChange = _this$props6.onBrushChange,
      axis = _this$props6.axis,
      width = _this$props6.width,
      height = _this$props6.height,
      timeline = _this$props6.timeline,
      instantaneousEventList = _this$props6.instantaneousEventList,
      getLabel = _this$props6.getLabel,
      getLabelColor = _this$props6.getLabelColor,
      getColor = _this$props6.getColor,
      getCategoryColor = _this$props6.getCategoryColor,
      getAlpha = _this$props6.getAlpha,
      onItemClick = _this$props6.onItemClick,
      time = _this$props6.time,
      interval = _this$props6.interval,
      extra = _objectWithoutPropertiesLoose(_this$props6, _excluded);
    var showEventList = this.state.showEventList;
    return /*#__PURE__*/_react["default"].createElement(StripeChartContainer, {
      "data-testid": "StripeChartContent"
    }, /*#__PURE__*/_react["default"].createElement("svg", _extends({
      width: width,
      height: height
    }, extra), showEventList && this.renderInstantaneousEventList(), this.renderStripeChartCanvas(), this.renderAxis()), showBrush && this.renderBrush(extra));
  };
  return StripeChartContent;
}(_react.Component), _StripeChartContent.contextType = _UiDesignContext.UiDesignContext, _StripeChartContent.defaultProps = {
  axis: true,
  showBrush: false,
  brushIsLocked: false,
  selection: undefined,
  time: undefined
}, _StripeChartContent)) || _class) || _class);